import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { FlowStateEnum, DebugSocketStateEnum } from 'enums'

export default {
  namespaced: true,
  state: () => ({
    flowDebugState: FlowStateEnum.STOPPED,
    debugSocket: null,
    logs: [],
    debugInputs: [],
    debugDelay: 0,
    debugSocketState: DebugSocketStateEnum.CLOSED,
    stellerDetected: null,
    debugSocketConf: {
      port: 0,
      securePort: 0,
      host: 'localhost'
    }
  }),
  getters: getters,
  mutations: mutations,
  actions: actions
}
